var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4",
    d: "M6 14L18 7.0718V20.9282L6 14Z",
    fill: "#0C2D1A"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 12,
    cy: 12,
    r: 13,
    transform: "matrix(-1 0 0 1 26 2)",
    stroke: "#0C2D1A",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLft);
export default __webpack_public_path__ + "static/media/lft.eab9131364ff1f045b067354308c82b9.svg";
export { ForwardRef as ReactComponent };